import {
    Button,
    Container,
    Form,
    FormGroup,
    Input,
    Segment,
    SegmentContent,
    SegmentHeader,
    TabNav,
    TabNavItem,
    Textarea,
} from '@/platform/ui';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Link, useForm, usePage } from '@inertiajs/react';
import { useEffect, useMemo, useState } from 'react';
import Navigation from '../components/Navigation';
import { availableLanguages } from '../definitions';

const CreateOrUpdateView = () => {
    const [locale, setLocale] = useState('nl');
    const { option } = usePage().props;
    const { data, setData, post, patch, errors, processing } = useForm({});

    useEffect(() => {
        if (option?.id) {
            setData(option);
        }
    }, [option?.id]);

    const title = useMemo(
        () =>
            option?.id
                ? 'Wijzig vragenlijst optie'
                : 'Nieuwe vragenlijst optie',
        [option]
    );

    const handleSubmit = () => {
        if (option?.id) {
            patch(`/questionnaires/options/${option.id}`);

            return;
        }

        post('/questionnaires/options');
    };

    return (
        <Container>
            <Navigation />

            <Form onSubmit={handleSubmit}>
                <Segment>
                    <SegmentHeader header={title}>
                        <Button as={Link} href='/questionnaires/options'>
                            <ArrowLeftIcon className='size-5' />
                            Terug
                        </Button>
                    </SegmentHeader>
                    <SegmentContent>
                        <TabNav label='Talen'>
                            {availableLanguages.map(language => (
                                <TabNavItem
                                    key={language.key}
                                    active={language.key === locale}
                                    onClick={() => setLocale(language.key)}
                                >
                                    {language.text}
                                </TabNavItem>
                            ))}
                        </TabNav>
                        <FormGroup>
                            <Input
                                label='Label'
                                required
                                value={data?.label?.[locale] || ''}
                                onChange={event =>
                                    setData(
                                        `label.${locale}`,
                                        event.target.value
                                    )
                                }
                                error={
                                    errors?.[`label.${locale}`] || errors?.label
                                }
                            />
                            <Textarea
                                label='Beschrijving'
                                value={data?.description?.[locale] || ''}
                                onChange={event =>
                                    setData(
                                        `description.${locale}`,
                                        event.target.value
                                    )
                                }
                                error={
                                    errors?.[`description.${locale}`] ||
                                    errors?.description
                                }
                            />
                        </FormGroup>
                    </SegmentContent>
                </Segment>

                <Segment floating>
                    <SegmentContent right>
                        <Button
                            type='submit'
                            variant='primary'
                            loading={processing}
                        >
                            Opslaan
                        </Button>
                    </SegmentContent>
                </Segment>
            </Form>
        </Container>
    );
};

export default CreateOrUpdateView;
